import { render, staticRenderFns } from "./common-poster-exsupply.vue?vue&type=template&id=0bd0b52e&scoped=true&"
import script from "./common-poster-exsupply.vue?vue&type=script&lang=js&"
export * from "./common-poster-exsupply.vue?vue&type=script&lang=js&"
import style0 from "./common-poster-exsupply.vue?vue&type=style&index=0&id=0bd0b52e&lang=scss&scoped=true&"
import style1 from "./common-poster-exsupply.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd0b52e",
  null
  
)

export default component.exports